import React from 'react';

/**
 * Red / Yellow / Green single-select question card.
 *
 * Renders three selectable options, each tinted with its sentiment
 * colour, used throughout the Annual Check-In wellness questions.
 *
 * @param {string} id - Unique field id (used for the radio group name).
 * @param {Array<{value: 'red'|'yellow'|'green', label: string}>} options
 * @param {string} value - Currently selected value.
 * @param {function} onChange - Called with the newly selected value.
 */
export default function RYGRadio({ id, options, value, onChange }) {
  return (
    <div className="ryg-radio-group">
      {options.map((opt) => {
        const isActive = value === opt.value;
        return (
          <label
            key={opt.value}
            className={`ryg-radio-option ryg-radio-option--${opt.value} ${isActive ? 'ryg-radio-option--active' : ''}`}
            htmlFor={`${id}_${opt.value}`}
          >
            <input
              type="radio"
              id={`${id}_${opt.value}`}
              name={id}
              className="ryg-radio-input"
              checked={isActive}
              onChange={() => onChange(opt.value)}
            />
            <span className="ryg-radio-swatch" aria-hidden="true">
              {isActive && <i className="bi bi-check-lg" />}
            </span>
            <span className="ryg-radio-text">
              <strong className="ryg-radio-tag">{opt.value.toUpperCase()}</strong>
              {' — '}
              {opt.label}
            </span>
          </label>
        );
      })}
    </div>
  );
}
